import {ApiResponse} from "../models";
import apiClient from "./api/apiClient";
import {handleApiError} from "./api/apiErrorHandler";

export interface CommunicationPreferences {
    marketingEmailStatus: number;
    pushNotificationsStatus: number;
}

export interface GetCommunicationPreferencesResponse extends ApiResponse {
    results: CommunicationPreferences;
}

class PreferencesService {

    async getCommunicationPreferences(customerId: number): Promise<GetCommunicationPreferencesResponse> {
        return await apiClient
            .get(`${this.baseUrl}/communication/${customerId}`)
            .then(
                (response) => response.data,
                (error) => handleApiError(error, "Failed to retrieve communication preferences.")
            );
    }

    async updateCommunicationPreferences(customerId: number, data: { marketing_email_status: number; marketing_email_reason?: string; push_notifications_status?: number }): Promise<ApiResponse> {
        return await apiClient
            .post(`${this.baseUrl}/communication/${customerId}`, data)
            .then(
                (response) => response.data,
                (error) => handleApiError(error, "Failed to update communication preferences.")
            );
    }

    constructor(private readonly baseUrl: string) {
    }
}

export const preferencesService = new PreferencesService(
    '/preferences'
);
